<footer class="bg-dark text-white py-5 border-top">
    <div class="container">
        <div class="row gy-4 text-center text-md-start">

            <!-- Brand -->
            <div class="col-md-4">
                <h4 class="fw-bold">ClockFlex</h4>
                <p class="small footer-copyright">
                    {{ 'tagline' | translate }}
                </p>

                <div class="mt-3 small">
                    <p class="mb-1">
                        <strong>{{ 'email' | translate }}:</strong>
                        <a href="mailto:contact@clockflex.com" class="footer-link">
                            contact&#64;clockflex.com
                        </a>
                    </p>
                    <p class="mb-0">
                        <strong>{{ 'phone' | translate }}:</strong>
                        +91 8180974296
                    </p>
                </div>
            </div>

            <!-- Links + Address -->
            <div class="col-md-4">
                <h5 class="fw-semibold">
                    {{ 'quickLinks' | translate }}
                </h5>

                <ul class="list-unstyled mb-3">
                    <li>
                        <a [routerLink]="'/documentation'" class="footer-link">
                            {{ 'documentation' | translate }}
                        </a>
                    </li>
                    <li>
                        <a [routerLink]="'/contact-us'" class="footer-link">
                            {{ 'contact' | translate }}
                        </a>
                    </li>
                    <li>
                        <a [routerLink]="'/terms-of-service'" class="footer-link">
                            {{ 'terms' | translate }}
                        </a>
                    </li>
                    <li>
                        <a [routerLink]="'/privacy-policy'" class="footer-link">
                            {{ 'privacy' | translate }}
                        </a>
                    </li>
                </ul>

                <div class="small">
                    <strong>{{ 'address' | translate }}:</strong>
                    <p class="mb-0 mt-1">
                        SaaSFlex<br>
                        B-503, 5th Floor,<br>
                        Empire Business Hub,<br>
                        Sola, Ahmedabad - 380060
                    </p>
                </div>
            </div>

            <!-- Social -->
            <div class="col-md-4 text-md-end">
                <h5 class="fw-semibold">
                    {{ 'followUs' | translate }}
                </h5>

                <div class="d-flex justify-content-center justify-content-md-end mb-3">
                    <a href="https://www.facebook.com/profile.php?id=61571830585615" target="_blank"
                        class="social-icon">
                        <i class="fab fa-facebook"></i>
                    </a>

                    <a href="https://x.com/clock_flex" target="_blank" class="social-icon">
                        <i class="fab fa-x-twitter"></i>
                    </a>

                    <a href="https://www.instagram.com/clock_flex" target="_blank" class="social-icon">
                        <i class="fab fa-instagram"></i>
                    </a>

                    <a href="https://www.linkedin.com/company/clock-flex/" target="_blank" class="social-icon">
                        <i class="fab fa-linkedin"></i>
                    </a>
                </div>

                <div class="mb-3">
                    <label for="languageSelect" class="me-2">
                        {{ 'language' | translate }}:
                    </label>

                    <select id="languageSelect" class="form-select d-inline-block w-auto" [(ngModel)]="selectedLanguage"
                        (change)="changeLanguage($event)">
                        <option value="en">English</option>
                        <option value="hi">हिन्दी</option>
                        <option value="gu">ગુજરાતી</option>
                    </select>
                </div>

                <div class="small">
                    <strong>{{ 'businessHours' | translate }}:</strong><br>
                    Mon - Fri, 9:00 AM - 6:00 PM
                </div>
            </div>

        </div>

        <hr class="my-4 border-light opacity-25">

        <div class="text-center footer-copyright">
            {{ 'copyright' | translate }}
        </div>
    </div>
</footer>